"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Container_1 = __importDefault(require("@mui/material/Container"));
var material_1 = require("@mui/material");
var Facebook_1 = __importDefault(require("@mui/icons-material/Facebook"));
var Twitter_1 = __importDefault(require("@mui/icons-material/Twitter"));
var Footer = function () {
    var iconStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "transparent",
        color: "#555",
        margin: "0 8px",
        transition: "all 0.3s ease-in-out",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        "&:hover": {
            backgroundColor: "#3B5998",
            color: "#fff",
        },
    };
    return (React.createElement(Box_1.default, { component: "footer", sx: { bgcolor: "#F2F2F2" } },
        React.createElement(Container_1.default, { maxWidth: "lg", sx: { py: 8 } },
            React.createElement(Grid_1.default, { container: true, spacing: 8 },
                React.createElement(Grid_1.default, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(material_1.Typography, { variant: "h6", sx: { mb: 2 } }, "Connect with us"),
                    React.createElement(Grid_1.default, { container: true, justifyContent: "flex-start" },
                        React.createElement(Box_1.default, { component: "a", href: "#", sx: iconStyle },
                            React.createElement(Facebook_1.default, null)),
                        React.createElement(Box_1.default, { component: "a", href: "#", sx: iconStyle },
                            React.createElement(Twitter_1.default, null)))),
                React.createElement(Grid_1.default, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(material_1.Typography, { variant: "h6", sx: { mb: 2 } }, "About us"),
                    React.createElement(material_1.Typography, { variant: "body2", sx: { mb: 2 } }, "We are a team of experienced developers building amazing products for our clients.")),
                React.createElement(Grid_1.default, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(material_1.Typography, { variant: "h6", sx: { mb: 2 } }, "Contact us"),
                    React.createElement(material_1.Typography, { variant: "body2", sx: { mb: 2 } }, "Email: contact@ecommerce.com"),
                    React.createElement(material_1.Typography, { variant: "body2", sx: { mb: 2 } }, "Phone: +250 788 000 000")),
                React.createElement(Grid_1.default, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(material_1.Typography, { variant: "h6", sx: { mb: 2 } }, "Links"),
                    React.createElement("ul", { style: { listStyle: "none", margin: 0, padding: 0 } },
                        React.createElement("li", { style: { marginBottom: 1 } },
                            React.createElement(Link_1.default, { href: "#", color: "textPrimary", variant: "body2" }, "Licence")),
                        React.createElement("li", { style: { marginBottom: 1 } },
                            React.createElement(Link_1.default, { href: "#", color: "textPrimary", variant: "body2" }, "Terms & Condition"))))),
            React.createElement(material_1.Typography, { variant: "body2", sx: { mt: 4, textAlign: "center" } },
                "© ",
                React.createElement(Link_1.default, { href: "", color: "textPrimary" }, "E-Commerce"),
                " ",
                new Date().getFullYear(),
                "."))));
};
exports.default = Footer;
